import { CloudArrowDownIcon } from '@heroicons/react/24/solid'
import Link from 'next/link'

export const MagicDownloadsLinks = () => {
  return (
    <div>
      <h2 className="text-vi-gray border-y-2 border-vi-gray text-xl font-bold p-2 pb-1 hover:bg-gray-100">
        <Link prefetch={false} href="/magic-downloads/">
          <CloudArrowDownIcon className="w-8 h-8 inline-block mb-1" /> Magic
          downloads
        </Link>
      </h2>
      <ul>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link
            prefetch={false}
            href="/masterclass/"
            className="text-vi-red block"
          >
            VI Masterclass lectures
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link
            prefetch={false}
            href="/free-magic-downloads/"
            className="text-vi-red block"
          >
            Free magic tricks
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link
            prefetch={false}
            href="/card-magic-downloads/"
            className="text-vi-red block"
          >
            Card magic downloads
          </Link>
        </li>
        <li className="border-b border-gray-300 p-2 hover:bg-gray-100">
          <Link prefetch={false} href="/ebooks/" className="text-vi-red block">
            Magic ebooks
          </Link>
        </li>
      </ul>
    </div>
  )
}
